import Paccount from "../components/pensionerVerification/pensionerSlots/index";
// import Nav from "../components/Nav/nav";
// import Whatsapp from "../Whatsapp/whatsapp";

const PAccount = () => {
  return (
    <div>
      {/* <Nav /> */}
      <Paccount />
      {/* <Whatsapp/> */}
    </div>
  );
};

export default PAccount;
